import React, { useState } from 'react'
import { Item } from '../../../common/snippets';
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Button } from '@mui/material'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf';
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold';
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal';
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from '../BookingReports/BookingConstants';
import moment from 'moment';
import autoTable from 'jspdf-autotable'
import { focusElemnt, navigation3 } from '../../../common/helper';
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { headerColumnPartyTargetReport, headerFilterColumnPartyTargetReport } from '../common/reportConstants';
const PartyTargetVsAchivementTable = (props) => {
    const { tableData, loginData, partyCity, party, fromDate, toDate } = props
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const { generatePDF, load } = { ...state }
    const [showTable, setShowTable] = useState(true)
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const InsideRowContent = ({ item, index, fontVal }) => {
        return (
            <>
                {
                    item.isTotal ? (
                        <>
                            <TableRow>
                                <TableCell
                                    colSpan={7}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '500', textAlign: 'left', color: '#444' }}
                                >
                                    {item.SN}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                >
                                    {item.TargetAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '570', textAlign: 'right' }}
                                >
                                    {item.TargetProgress}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                >
                                    {item.TotalLRs}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                >
                                    {item.TotalItems}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                >
                                    {item.TotalNetAmounts}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: '#eeeeee', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                >
                                </TableCell>
                            </TableRow>
                        </>
                    ) : (
                        <>
                            <TableRow>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    <p style={{ textDecoration: 'underLine', color: '#0086ff' }}>{item.LRNo}</p>
                                    {item.SN}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.PartyName}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.CityName}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.BranchName}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.TargetStartDate}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.TargetEndDate}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.targetType}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TargetAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TargetProgress}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TotalLRs}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TotalItems}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TotalNetAmounts}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', whiteSpace: 'pre', fontSize: fontVal, fontWeight: '500', textAlign: 'left', color: item.status === 'Active' ? 'green' : 'red' }}
                                >
                                    {item.status}
                                </TableCell>
                            </TableRow>
                        </>
                    )}
            </>
        )
    }
    const printClick = (isSave) => {
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
        const widthCell = calculateTotalTableWidth(headerColumnPartyTargetReport)
        const HeaderColumns = headerFilterColumnPartyTargetReport.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const pdfColumns = headerColumnPartyTargetReport.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
        })
        const HeaderData = [
            {
                fromDate: moment(fromDate).format('DD-MMM-YYYY'),
                toDate: moment(toDate).format('DD-MMM-YYYY'),
                comapny: loginData?.strCompanyName,
                partyCity: partyCity?.CityName,
                party: party?.PartyName,
            },
        ]
        const doc = new jsPDF({ orientation: pdfColumns.length > 13 ? 'l' : 'p', format: pdfColumns.length > 13 ? calculateDynamicFormatLandscape((widthCell > 1400 ? widthCell : 1400) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
        var pageSize = doc.internal.pageSize
        // var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var scaleFactor = pageWidth / (pdfColumns.length > 13 ? 1122 : 793);

        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(scaleFactor * 14)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        let drawCell = function (data) {
            var rows = data.table.body
            rows.map((val) => { 
                if (val.raw.isSubHeading) {
                    let prevColSpan = 0;
                    for (let key in val.raw) {
                        if (key !== 'isSubHeading') {
                            val.cells[prevColSpan].text = val.raw[key]
                            val.cells[prevColSpan].styles.font = 'Roboto'
                            val.cells[prevColSpan].styles.fontStyle = 'normal'
                            val.cells[prevColSpan].styles.fontSize = scaleFactor * 12
                            val.cells[prevColSpan].styles.halign = (key === 'CancelByUser' ? 'right' : 'left')
                            val.cells[prevColSpan].styles.fillColor = [241, 249, 255]
                            val.cells[prevColSpan].styles.textColor = [0, 0, 0]
                            val.cells[prevColSpan].styles.cellPadding = 6
                            val.cells[prevColSpan].styles.minCellHeight = 36
                            val.cells[prevColSpan].styles.valign = 'middle'
                            val.cells[prevColSpan].colSpan = key === 'CancelByUser' ? pdfColumns.length - (Math.floor(pdfColumns.length / 2)) : Math.floor(pdfColumns.length / 2)
                            prevColSpan += key === 'CancelByUser' ? pdfColumns.length - (Math.floor(pdfColumns.length / 2)) : Math.floor(pdfColumns.length / 2)
                        }
                    }
                }
                if (val.raw.isTotal) {
                    val.cells[0].colSpan = 5
                    // val.cells[0].text = val?.raw?.LrManNo
                    val.cells[0].styles.font = 'Roboto'
                    val.cells[0].styles.fontStyle = 'normal'
                    val.cells[0].styles.fontSize = scaleFactor * 12
                    val.cells[0].styles.halign = 'right'
                    val.cells[0].styles.valign = 'middle'
                    val.cells[0].styles.fillColor = [238, 238, 238]
                    val.cells[0].styles.textColor = [0, 0, 0]
                    val.cells[0].styles.cellPadding = 6
                }
            })
        }
        doc.setProperties({
            title: `Party target Vs Achivement Report.pdf`,
            subject: 'Party target Vs Achivement Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                5: { fontSize: scaleFactor * 14, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            startY: 160,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: scaleFactor * 14,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
        })

        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: scaleFactor * 12,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor: [0, 0, 0]
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: tableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2]
            },
            columnStyles: {
                0: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 70, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                5: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                6: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'left', textColor: [0, 0, 0] },
                7: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                8: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 53, halign: 'right', textColor: [0, 0, 0] },
                9: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
                10: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
                11: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'right', textColor: [0, 0, 0] },
                12: { fontSize: scaleFactor * 12, valign: "top", font: 'Roboto', fontStyle: "normal", cellPadding: 6, minCellHeight: 36, minCellWidth: 30, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            // showHead: "never",
            didParseCell: (data) => {
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
                drawCell(data)
            },
            willDrawCell: (data) => {
                if (data.row.raw.isHeading) {
                    doc.setFillColor(191, 225, 255)
                    // doc.setFillColor(241, 249, 255)
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
                } else if (data.row.raw.isSubHeading) {
                    doc.setFillColor(241, 249, 255)
                    // doc.setFillColor(191, 225, 255)
                    doc.setTextColor(0, 0, 0)
                    doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
                } else if (data.row.raw.isTotal) {
                    doc.setFillColor(238, 238, 238)
                    doc.setTextColor(0, 0, 0)
                    // doc.cell.styles.valign='middle'
                    data.cell.styles.valign = 'middle';
                    doc.setFontSize(scaleFactor * 12).setFont(undefined, 'bold')
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(scaleFactor * 40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Party target Vs Achivement Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(scaleFactor * 20).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Party Target Vs Achivement report ${currentDateTime}.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('LrCancelAndPenalityReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
                focusElemnt('backBtn')
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                document.getElementById('LrCancelAndPenalityReportoutput').data = doc.output('datauristring', 'DeliveryDetailedReport..pdf')
                focusElemnt('backBtn')
            }, 2000)
        }
    }
    return (
        <>
            <Item className="userReport">
                <Item style={{ padding: '8px 0 0 15px' }} className="userReport-heading">Report For:  Party Target Vs Achivement Report</Item>
                <Item className="userReport-buttons">
                    {showTable ? (
                        <>
                            {/* {disableExcel ? (
                                <Box>
                                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>
                                        Export to Excel
                                    </Button>
                                </Box>
                            ) : ( */}
                            <Box id={'ExpToExlbtnBox'}>
                                <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, 'PdfBtn', 'generateButton', () => { })}>
                                    <ReactHtmlTableToExcel
                                        id="ExpToExlbtn"
                                        className="userWisereporttemExcelBtn"
                                        table="table-to-xls"
                                        filename={`Party Target Vs Achivement Report ${currentDateTime}`}
                                        sheet="tablexls"
                                        buttonText="Export to Excel"
                                    />
                                </Item>
                            </Box>
                            {/* )} */}
                            <Box>
                                <Button
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setShowTable(false); printClick(true) }}
                                    onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                                    id="PdfBtn"
                                >
                                    Export to Pdf
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setShowTable(false); printClick(false) }}
                                    id="PrintBtn"
                                    onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => { })}
                                >
                                    Print
                                </Button>
                            </Box>
                        </>
                    ) : (
                        <>
                            <Box>
                                <Button
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => setShowTable(true)}
                                    onKeyDown={(e) => navigation3(e, '', 'generateButton', () => { setShowTable(true); focusElemnt('generateButton') })}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>
                    )}
                </Item>
            </Item>
            {showTable ? (<>
                <Stack sx={{ marginLeft: 2, marginRight: 2, height: 450, paddingTop: '10px' }}>
                    <TableContainer className="scroll" style={{ border: '1px solid #aeaeae', borderRadius: '6px' }}>
                        <Table className="table1 table-Report" size="small" aria-label="a dense table">
                            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                                <TableRow>
                                    {headerColumnPartyTargetReport?.map((i, index) =>
                                        <TableCell
                                            key={index}
                                            className="ReportItemHead"
                                            style={{
                                                backgroundColor: '#bfe1ff',
                                                color: '#444444',
                                                fontSize: '12px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                textAlign: `${i.align}`,
                                                whiteSpace: 'pre'
                                            }}
                                            colSpan={1}
                                        >
                                            {i.headerName}
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={7}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                        <Table id="table-to-xls" style={{ display: 'none' }} className="table1 table-Report" size="small" aria-label="a dense table">
                            <TableHead >
                                <TableRow>
                                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={5}>
                                        <h3 style={{ paddingLeft: '17px' }}>Report For: Party Target Vs Achivement Report</h3>
                                    </TableCell>
                                    <TableCell className="reportTD" style={{ fontSize: '25px', fontWeight: '500', textAlign: 'left' }} colSpan={4}>
                                        <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={7}></TableCell>
                                </TableRow>
                                <TableRow>
                                    {headerFilterColumnPartyTargetReport?.map((i, index) =>
                                        <TableCell
                                            key={index}
                                            className="ReportItemHead"
                                            style={{
                                                backgroundColor: '#bfe1ff',
                                                color: '#444444',
                                                fontSize: '20px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                textAlign: `${i.align}`,
                                            }}
                                            colSpan={2}
                                        >
                                            {i.headerName}
                                        </TableCell>
                                    )}
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={2}
                                    >
                                        {loginData.strCompanyName}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={2}
                                    >
                                        {moment(fromDate).format('DD-MMM-YYYY')}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={2}
                                    >
                                        {moment(toDate).format('DD-MMM-YYYY')}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={2}
                                    >
                                        {partyCity?.CityName}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                        colSpan={2}
                                    >
                                        {party?.PartyName}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell colSpan={7}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                                <TableRow>
                                    {headerColumnPartyTargetReport?.map((i, index) =>
                                        <TableCell
                                            key={index}
                                            className="ReportItemHead"
                                            style={{
                                                backgroundColor: '#bfe1ff',
                                                color: '#444444',
                                                fontSize: '20px',
                                                lineheight: '16px',
                                                letterspacing: '0.24px',
                                                fontWeight: '500',
                                                textAlign: `${i.align}`,
                                            }}
                                            colSpan={1}
                                        >
                                            {i.headerName}
                                        </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={7}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} fontVal={'20px'} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                    </TableContainer>
                </Stack>
            </>
            ) : (
                <>
                    {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                    {load ? (
                        <object
                            id="LrCancelAndPenalityReportoutput"
                            type="application/pdf"
                            width={'100%'}
                            height="440"
                            title="MTLPL -Cargo System - After Transfer Summary Report"
                            aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                        ></object>
                    ) : (
                        ''
                    )}
                </>
            )}

        </>
    )
}

export default PartyTargetVsAchivementTable